import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleStudentReportDailyWorkload } from 'domain/usecases';

export class RemoteGetStudentReportDailyWorkload
  implements HandleStudentReportDailyWorkload
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleStudentReportDailyWorkload.Result>,
  ) {}

  async execute(
    params: HandleStudentReportDailyWorkload.Params,
  ): Promise<HandleStudentReportDailyWorkload.Result> {
    const { model, type, ...rest } = params;
    const url = `${this.url}/${model}/${type}`;
    const requestUrl = generateUrl(url, rest as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
